import store from "store";

export const StoreLandingUrl = () => {
  const THIRTY_DAYS_IN_MS = 30 * 24 * 60 * 60 * 1000;
  const existingLandingPageInfo = store.get("landingPageInfo");
  const isLandingPageInfoExpired =
    !existingLandingPageInfo?.time ||
    Date.now() - existingLandingPageInfo.time > THIRTY_DAYS_IN_MS

  let urlHasUtm = false;
  try {
    urlHasUtm = new URL(window.location.href).searchParams.has("utm_source");
  } catch (e) {
    urlHasUtm = window.location.href.includes("utm_source=");
  }

  if (urlHasUtm && existingLandingPageInfo) {
    store.set("landingPageInfo", {
      LandingPageUrl: window.location.href,
      time: Date.now(),
    });
    return;
  }

  if (isLandingPageInfoExpired) {
    store.set("landingPageInfo", {
      LandingPageUrl: window.location.href,
      time: Date.now(),
    });
  }
};